import React, { useEffect, useState } from 'react';

// Ownezzy's logo: the one a Super Admin uploaded in the admin panel (Settings -> Ownezzy logos), or the files in
// public/brand. The page shows the shipped file first and swaps it if a newer one is set.
const DEFAULT_LOGOS = { logo: '/brand/logo-192.png', logoWide: '/brand/logo-wide.jpg', favicon: '/brand/favicon-32.png' };
let request = null;

// GET /api/branding, once for the page: { branding: the logos, contact: Ownezzy's email and WhatsApp }
export function loadBrandingData() {
  if (!request) {
    request = fetch('/api/branding')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => data || {})
      .catch(() => ({}));
  }
  return request;
}
const loadBranding = () => loadBrandingData().then((data) => data.branding || {});

export function useOwnezzyLogos() {
  const [logos, setLogos] = useState(DEFAULT_LOGOS);
  useEffect(() => {
    let live = true;
    loadBranding().then((branding) => {
      if (!live) return;
      setLogos({ logo: branding.logo || DEFAULT_LOGOS.logo, logoWide: branding.logoWide || DEFAULT_LOGOS.logoWide, favicon: branding.favicon || DEFAULT_LOGOS.favicon });
      if (branding.favicon) document.querySelectorAll('link[rel="icon"]').forEach((link) => { link.href = branding.favicon; });
    });
    return () => { live = false; };
  }, []);
  return logos;
}

// The shipped wide logo also has small WebP copies (scripts/make-webp.sh); it is shown at most 176px wide
const DEFAULT_WIDE_WEBP = '/brand/logo-wide-450.webp 450w, /brand/logo-wide-900.webp 900w';

export default function OwnezzyLogo({ className = '' }) {
  const { logoWide } = useOwnezzyLogos();
  const img = <img className={`ownezzy-logo ${className}`} src={logoWide} alt="Ownezzy" width="900" height="194" />;
  if (logoWide !== DEFAULT_LOGOS.logoWide) return img;
  return (
    <picture>
      <source type="image/webp" srcSet={DEFAULT_WIDE_WEBP} sizes="176px" />
      {img}
    </picture>
  );
}
